module.exports = "/images/tropical-cyclone@3x.png?7a253205f3b7093a29648215461afc37";